import { useToast } from "@chakra-ui/react";
import { FC, ReactNode, createContext, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

type User = {
    firstName: string
    lastName: string
}

type AuthContextProps = {
    isAuthenticated: boolean
    login: (username: string, password: string) => void
    user: User
    logout: () => void
}

export const AuthContext = createContext<Partial<AuthContextProps>>({})

export const useAuthContext = () => useContext(AuthContext)

type AuthProviderProps = {
    children: ReactNode
}

export const AuthProvider: FC<AuthProviderProps> = ({children}) => {
    const [accessToken, setAccessToken] = useState<string>()
    const [user, setUser] = useState<User>()
    const navigate = useNavigate()
    const toast = useToast()

    const isAuthenticated = useMemo(() => {
        if(!accessToken){
            return false
        }else{
            // Check validity

            return true
        }
    }, [accessToken])

    useEffect(() => {
        if(isAuthenticated){
            navigate('/api')
        }else{
            navigate('/')
        }
    }, [isAuthenticated])

    const login = (username: string, password: string) => {

        if(username !== 'bobbycarelse@gmail.com'){
            toast({description: 'Invalid username/password', status: 'error' })
            return
        }

        if(password !== 'Qwerty9AD!'){
            toast({description: 'Invalid username/password', status: 'error' })
            return
        }
        // valid credentials

        setAccessToken('JWT_TOKEN')
        setUser({firstName: 'Bobby', lastName: 'Carelse'})
    }

    const logout = () => {
        setUser(undefined)
        setAccessToken(undefined)
    }

    return <AuthContext.Provider value={{isAuthenticated, login, user, logout}}>
        {children}
    </AuthContext.Provider>
}